import { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SectionDividerProps {
  tone: 'strong' | 'moderate' | 'weak';
  count: number;
  children: React.ReactNode;
  defaultCollapsed?: boolean;
}

const TONES = {
  strong: { label: 'Forte pertinence', sub: '≥ 70', color: 'text-emerald-700' },
  moderate: { label: 'Modérée', sub: '40 — 69', color: 'text-amber-700' },
  weak: { label: 'Faible', sub: '< 40', color: 'text-rose-700' },
} as const;

export function SectionDivider({
  tone,
  count,
  children,
  defaultCollapsed = false,
}: SectionDividerProps) {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);
  const { label, sub, color } = TONES[tone];

  if (count === 0) return null;

  return (
    <section className="space-y-3">
      <button
        type="button"
        onClick={() => setCollapsed((v) => !v)}
        className="flex items-center gap-2 w-full hover:opacity-80"
      >
        {collapsed ? (
          <ChevronRight className="h-4 w-4" />
        ) : (
          <ChevronDown className="h-4 w-4" />
        )}
        <h2 className={cn('text-sm font-semibold', color)}>
          {label} <span className="font-normal text-muted-foreground">({sub})</span>
        </h2>
        <span className="text-xs text-muted-foreground tabular-nums">{count} suggestion{count > 1 ? 's' : ''}</span>
      </button>
      {!collapsed && <div className="space-y-3 pl-6">{children}</div>}
    </section>
  );
}
